import { createSlice } from "@reduxjs/toolkit"
import {toast, ToastContainer } from "react-toastify";

export const forgetPasswordSlice = createSlice({
	name: "forget_password",
	initialState: {
		forgetPassMessage: "",
		reset_phone: "",
		errors: [],
	},

	reducers: {
		getForgetPassMessage: (state, action) => {
			state.forgetPassMessage = action.payload
		},
		getUserNewPhone: (state, action) => {
			state.reset_phone = action.payload.phone
			// console.log(action.payload, "reducer")
		},
		getForgetPassMessageSuccess: (state, action) => {
			state.forgetPassMessage = action.payload
		},
		// forget the previous request so revisiting the page doesn't act on an old success
		clearForgetPassState: (state) => {
			state.forgetPassMessage = ""
			state.errors = []
		},
		getErrors: (state, action) => {
			state.errors = action.payload
			// console.log(action.payload, "error from reducer")
			if(action.payload.non_field_errors){
				toast.error(`${action.payload.non_field_errors}`, {
					position: "top-right",
					autoClose: 1500,
					hideProgressBar: false,
					closeOnClick: true,
					pauseOnHover: true,
					draggable: true,
					progress: undefined,
				})
			}
		 
		},
	},
})

// Action creators are generated for each case reducer function
export const {getForgetPassMessage, getForgetPassMessageSuccess, getErrors, getUserNewPhone, clearForgetPassState} = forgetPasswordSlice.actions

export default forgetPasswordSlice.reducer
